import React from "react";
import styles from "../SignHeader.module.css";
import SignHeaderButtons from "./SignHeaderButtons";
import { useLocation } from "react-router-dom";

const SignDesktopNav = ({ toggleNavbar, activeHash, openLogin, openRegister, isHovered, setIsHovered }) => {
    const location = useLocation();

    return (
        <div className={styles.desktopView}>
            <nav className={`${styles.navbar}`}>
                <a
                    className={location.pathname === "/home" ? styles.activeLink : ""}
                    href="/home">
                    Home
                </a>

                <a
                    className={location.pathname === "/product" ? styles.activeLink : ""}
                    href="/product">
                    Product
                </a>

                <a
                    className={location.pathname === "/package" ? styles.activeLink : ""}
                    href="/package">
                    Packages
                </a>

                <a
                    className={location.pathname === "/contact-us" ? styles.activeLink : ""}
                    href="/contact-us">
                    Contact Us
                </a>
            </nav>
            <SignHeaderButtons
                toggleNavbar={toggleNavbar}
                openLogin={openLogin}
                openRegister={openRegister}
                isHovered={isHovered}
                setIsHovered={setIsHovered}
                // setIsHovered={() => { }}
            />
        </div>
    );
};

export default SignDesktopNav;
